var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGreat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.36752 17.479C7.46262 17.479 8.35038 16.5912 8.35038 15.4961C8.35038 14.401 7.46262 13.5132 6.36752 13.5132C5.27241 13.5132 4.38465 14.401 4.38465 15.4961C4.38465 16.5912 5.27241 17.479 6.36752 17.479Z",
    fill: "#CED5EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.665 17.479C27.7601 17.479 28.6479 16.5912 28.6479 15.4961C28.6479 14.401 27.7601 13.5132 26.665 13.5132C25.5699 13.5132 24.6821 14.401 24.6821 15.4961C24.6821 16.5912 25.5699 17.479 26.665 17.479Z",
    fill: "#CED5EF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2171 19.3048H22.3747C22.7304 19.3048 23.0159 19.5925 23.0159 19.9453C23.0159 22.9428 20.0003 25.3848 16.2959 25.3848C12.5915 25.3848 9.5759 22.9453 9.5759 19.9453C9.5759 19.59 9.86143 19.3048 10.2171 19.3048Z",
    fill: "#CED5EF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.2985 16.4261C32.2985 25.2633 25.1344 32.4274 16.2972 32.4274C7.45992 32.4274 0.295898 25.2633 0.295898 16.4261C0.295898 7.58882 7.45992 0.424805 16.2972 0.424805C25.1344 0.424805 32.2985 7.58882 32.2985 16.4261ZM16.2972 30.8274C24.2508 30.8274 30.6985 24.3797 30.6985 16.4261C30.6985 8.47248 24.2508 2.0248 16.2972 2.0248C8.34357 2.0248 1.8959 8.47248 1.8959 16.4261C1.8959 24.3797 8.34357 30.8274 16.2972 30.8274Z",
    fill: "#CED5EF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreat);
export default __webpack_public_path__ + "static/media/great.2e9c230509cef581b23a27d6cf97fd78.svg";
export { ForwardRef as ReactComponent };